import type { Vendor } from "../../../../features/interfaces";

/** Single-responsibility check: vendor has a commerce integration configured. */
export function hasVendorIntegration(vendor: Vendor | null | undefined): boolean {
  return Boolean(vendor?.integration_type);
}

export function isVendorIntegrationActive(
  vendor: Vendor | null | undefined
): boolean {
  return hasVendorIntegration(vendor) && Boolean(vendor?.is_integration_active);
}
